import React from 'react';
import PropTypes from 'prop-types';

import { getTranslation } from '../../../../../../../../../common/react/utils/translations';
import { getGlossaryDefinitionFromColumnId } from '../../../../common/utils/get-glossary-definition-from-column-id';
import { StatsTableHead } from '../../../../common/stats-table/StatsTableHead';

export const StatsLeadersTableHead = ({ headerGroup }) => (
    <StatsTableHead
        headerGroup={headerGroup}
        skipColumns={['position', 'team']}
        primaryTooltipComponent={(column) => (
            <strong style={{ fontWeight: 500 }}>
                {getTranslation(`label.statsLeaders.${column.id}.name`)}
            </strong>
        )}
        secondaryTooltipComponent={(column) => {
            const glossaryDefinition = getGlossaryDefinitionFromColumnId(
                column.id
            );

            if (glossaryDefinition) {
                return (
                    <div className="stats-leaders-table-header-tooltip-secondary">
                        <div className="stats-leaders-table-header-tooltip-secondary__border" />
                        <p>{glossaryDefinition}</p>
                    </div>
                );
            }

            return null;
        }}
    />
);

StatsLeadersTableHead.propTypes = {
    headerGroup: PropTypes.object.isRequired
};
